

import React, { useEffect, useRef } from 'react';
import './Hero.css';
import heroVideo from '../assets/videos/Saudi Arabia2.mp4';

const Hero = () => {
  const videoBgRef = useRef(null);

  useEffect(() => {
    const handleScroll = () => {
      if (!videoBgRef.current) return;
      const scrollY = window.scrollY;
      // Parallax: move video slower than scroll
      videoBgRef.current.style.transform = `translateY(${scrollY * 0.3}px)`;
    };
    // Use rAF for smoothness
    let ticking = false;
    const onScroll = () => {
      if (!ticking) {
        window.requestAnimationFrame(() => {
          handleScroll();
          ticking = false;
        });
        ticking = true;
      }
    };
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <section id="home" className="hero">
      <div className="video-background" ref={videoBgRef}>
        <video 
          id="hero-video"
          src={heroVideo}
          autoPlay
          muted
          loop
          playsInline
        ></video>
        <div className="overlay"></div>
      </div>
      <div className="hero-content">
        <h1>Discover the World with <span style={{ fontStyle: 'italic' }}>Seder Travel & Tourism's</span></h1>
        <p className="hero-subheadline">Seamless journeys, unforgettable experiences.<br />
          Flights, hotels, visas & more—crafted for you.</p>
        <a href="#services" className="cta-button">Explore Our Services</a>
      </div>
    </section>
  );
};

export default Hero;
